<template>
    <teleport
    to="#spinner-overlay-teleport"
    :disabled="!isOverlay || fullSize">
        <div
        class="spinner-wrapper dont-close-centered-modals"
        :class="{
            'small-spinner': isSmall,
            'overlay-spinner': isOverlay,
            'dont-close-side-modals': isOverlay,
            'inside-centered-modal': insideCenteredModal,
            'full-size': fullSize,
            'full-size-overlay': fullSizeOverlay
        }">
            <login-particular-svg v-if="getClientType === 'particular' && getAppThemeMode === 'light'"/>
            <login-particular-dark-svg v-if="getClientType === 'particular' && getAppThemeMode === 'dark'"/>
            <login-company-svg v-if="getClientType === 'company' && getAppThemeMode === 'light'"/>
            <login-company-dark-svg v-if="getClientType === 'company' && getAppThemeMode === 'dark'"/>
        </div>
    </teleport>
</template>

<script setup>
import loginParticularSvg from '@/components/generic/loaders/loginParticularSvg.svg?inline'
import loginParticularDarkSvg from '@/components/generic/loaders/loginParticularDarkSvg.svg?inline'
import loginCompanySvg from '@/components/generic/loaders/loginCompanySvg.svg?inline'
import loginCompanyDarkSvg from '@/components/generic/loaders/loginCompanyDarkSvg.svg?inline'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* mapGetters */
const { getClientType, getAppThemeMode } = mapGetters()

/** Props received:
@isOverlay { Boolean }
@isSmall { Boolean }
@insideCenteredModal {Boolean} - to force styles for insideCenteredModal
@fullSize { Boolean } - to apply 100% width/heiht to ocupy all parent area
@fullSizeOverlay { Boolean } - to apply 100% width/heiht to ocupy all parent area and display above parent area
*/
const props = defineProps({
    isSmall: Boolean,
	isOverlay: Boolean,
    insideCenteredModal: Boolean,
    fullSize: Boolean,
    fullSizeOverlay: Boolean
})
</script>

<style lang="scss" scoped>
.spinner-wrapper {
    width: 56px;
    height: 56px;

    svg {
        width: 56px;
        height: 56px;
        overflow: visible;

        :deep(circle) {
            fill: none;

            &:not(:last-of-type) {
                stroke: var(--secondary-light-1);
            }
        }

        :deep(circle + circle) {
            stroke-linecap: round;

            animation: spinning 0.8s linear infinite;
        }
    }

    @keyframes spinning {
        100% {
            transform: rotate(360deg);
        }
    }

    &.small-spinner {
        width: 24px;
        height: 24px;

        svg {
            width: 24px;
            height: 24px;
        }
    }

    &.overlay-spinner {
        @include spinnerOverlayTeleportStyles;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.inside-centered-modal {
        @include spinnerOverlayTeleportStyles;
        border-radius: 8px;
    }

    &.full-size {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.full-size-overlay {
        @include spinnerOverlayTeleportStyles;
    }
}
</style>
